import React from "react";
import { Image } from "spectacle";
import confident from "./confident.gif";

export const S32a = () => <Image src={confident} />;
